import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'execute-workflow',
  version: '1.0.0',
  properties: [
    // Workflow Trigger nodes don't have any parameters
    // They simply receive data from the parent workflow via the ExecuteWorkflowNode
    // The data is automatically passed through the execution context
  ],
};

export default schema;
